import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "powerpoint",
  "use": "powerpoint-usage",
  "viewBox": "0 0 83.3 102.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 83.3 102.9\" id=\"powerpoint\"><style>#powerpoint .st3{fill:#fff}#powerpoint .st4{font-family:'Roboto-Regular'}#powerpoint .st5{font-size:14px}</style><path fill=\"#2ecc71\" d=\"M52.8 27.7V11.3H14v75.1h52V27.7z\" /><path fill=\"#68dd98\" d=\"M66 27.7L52.8 11.3v16.4z\" /><path fill=\"none\" d=\"M17.2 44.7h47.3v16.2H17.2z\" /><text transform=\"translate(16.317 51.453)\" class=\"st3 st4 st5\">POWER</text><text transform=\"translate(20.017 69.453)\" class=\"st3 st4 st5\">POINT</text></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/powerpoint.svg
// module id = iBmR
// module chunks = 1